import { Component, OnInit,ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators,FormGroupDirective  } from  '@angular/forms';
import { API } from 'src/app/shared/services/endpoints';
import { ApiHandlerService } from '../../shared/services/api-handler.service';
import { ToasterService } from '../../shared/services/toaster.service';

@Component({
  selector: 'app-career',
  templateUrl: './career.component.html',
  styleUrls: ['./career.component.scss']
})
export class CareerComponent implements OnInit {

  contactForm : FormGroup;
  public isLoadingData : boolean = false;
  public submitted :boolean =false;
  public addedQuery : boolean = false;
  // @ViewChild(FormGroupDirective) contactFormGroupDirective: FormGroupDirective;'

  constructor(
    public formBuilder : FormBuilder,
    public _service    : ApiHandlerService,
    public toaster : ToasterService) { }

    ngOnInit(): void {
      let footer = document.getElementsByTagName('footer');
      footer[0].classList.add('without-cars');
      if(footer[1]){
        footer[1].classList.add('without-cars');
      }
      this.getData();
    }

    ngOnDestroy(){
      let footer = document.getElementsByTagName('footer')[0];
      footer.classList.remove('without-cars');
    }

       public pageData:any;
       public jobData:any;
    getData(){
       var apiData = {
        page: 'career'
      }
      this._service.apiPost(API.CMS_ENDPOINTS.GET_PAGE, apiData).subscribe({
        next:next =>{
          console.log(next);
          this.pageData = next.data.page
          this.jobData = next.data.jobs
        },
        error:error =>{

        }
      });
    }


}

